module.exports = __webpack_public_path__ + "static/media/icon_pendingApprovals.ee1a7113.svg";